import { Button } from 'antd'
import classnames from 'classnames'

import Styled from './styled'

export default function MyButton({
  children,
  type = 'primary',
  size = 'default', //large, small, default
  dynamic = false,
  className,
  ...props
}) {
  return (
    <Styled className="button-component">
      <Button
        size={size}
        className={classnames(
          {
            primary: type === 'primary',
            ghost: type === 'ghost',
            dynamic,
          },
          className
        )}
        type={type}
        {...props}
      >
        {children}
      </Button>
    </Styled>
  )
}
